/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Pit2_DInputs */

const en_formatter_pit2_d = /** @type {(inputs: Formatter_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments and trailing commas belong to JSON5 and JSONC, not to JSON. The parse step rejects them, so you get an error rather than cleaned up output. If you are formatting a tsconfig.json or a VS Code settings file, strip the comments first or use a JSONC aware tool.`)
};

const ko_formatter_pit2_d = /** @type {(inputs: Formatter_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석과 뒤쪽 쉼표는 JSON이 아니라 JSON5와 JSONC의 것입니다. 파싱 단계에서 거부되므로 정리된 출력이 아니라 오류가 나옵니다. tsconfig.json이나 VS Code 설정 파일을 다루고 있다면 주석을 먼저 제거하거나 JSONC를 이해하는 도구를 쓰세요.`)
};

const ja_formatter_pit2_d = /** @type {(inputs: Formatter_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントと末尾カンマは JSON ではなく JSON5 や JSONC のものです。パース段階で拒否されるため、整えられた出力ではなくエラーが返ります。tsconfig.json や VS Code の設定ファイルを扱っているなら、先にコメントを取り除くか、JSONC を理解するツールを使ってください。`)
};

/**
* | output |
* | --- |
* | "Comments and trailing commas belong to JSON5 and JSONC, not to JSON. The parse step rejects them, so you get an error rather than cleaned up output. If you a..." |
*
* @param {Formatter_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_pit2_d = /** @type {((inputs?: Formatter_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_pit2_d(inputs)
	if (locale === "ko") return ko_formatter_pit2_d(inputs)
	return ja_formatter_pit2_d(inputs)
});